<template>
  <div>
    <a-table
      :data-source="data"
      :columns="columns"
      :row-key="getRowKey"
      :loading="loading"
    >
      <template #action="{ record }">
        <div class="action-cell">
          <a-col>
            <a-tooltip color="#05045D" title="Editar vigencia">
              <a-button type="link" @click="$emit('edit-dates', record)">
                <template #icon>
                  <edit-outlined class="blue-icon" />
                </template>
              </a-button>
            </a-tooltip>
          </a-col>
          <a-col>
            <a-tooltip color="#05045D" title="Dar de baja">
              <a-button type="link" @click="$emit('unsubscribe', record)">
                <template #icon>
                  <download-outlined />
                </template>
              </a-button>
            </a-tooltip>
          </a-col>
          <a-col>
            <a-tooltip color="#05045D" title="Eliminar">
              <a-button type="link" @click="$emit('delete', record)">
                <template #icon>
                  <delete-outlined class="red-icon" />
                </template>
              </a-button>
            </a-tooltip>
          </a-col>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import {
  EditOutlined,
  DownloadOutlined,
  DeleteOutlined
} from '@ant-design/icons-vue';

defineProps({
  data: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
});

defineEmits(['edit-dates', 'unsubscribe', 'delete']);

const columns = [
  {
    title: 'Aseguradora',
    dataIndex: 'insuranceCompany.businessName',
    key: 'insuranceCompany.businessName'
  },
  {
    title: 'N° Póliza',
    dataIndex: 'policy.numberPolicy',
    key: 'policy.numberPolicy'
  },
  {
    title: 'Grupo',
    dataIndex: 'groupCompany.name',
    key: 'groupCompany.name'
  },
  {
    title: 'Cobertura',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Vigencia',
    dataIndex: 'vigencia',
    key: 'vigencia'
  },
  {
    title: 'Acción',
    dataIndex: 'id',
    key: 'id',
    slots: {
      customRender: 'action'
    }
  }
];

const getRowKey = (record) => record.id;
</script>

<style scoped>
.action-cell {
  display: flex;
  align-items: center;
  gap: 4px;
}
.blue-icon {
  color: #05045d;
}
.red-icon {
  color: #ff4d4f;
}
</style>
